export default "__VITE_PUBLIC_ASSET__e0e31f1a__"